import Image from "next/image"

export default function GithubRepo({ link = "/" }) {
  return (
    <div className="mt-8">
      <div 
        className="skill cursor-pointer relative w-32 h-32 lg:w-26 lg:h-26 py-4 my-1 border transition"
        style={{ "backgroundColor": "#181717" }} 
        onClick={ () => { window.open(link, '_blank') } }>
        <div className="relative w-full h-full">
          <Image
            fill={true}
            className="transition p-2"
            src="svgs/github.svg" 
            alt="GitHub Repo Link">
          </Image>
        </div>
      </div>
      <a className="cursor-pointer text-[1.05rem] cl-foreground underline font-bold italic"
         onClick={ () => { window.open(link, '_blank') } }>
        View Source
      </a>
    </div>
  );

}